// Form names
export const FORM_WHOLESALERS = 'form_wholesale'

export const FILEUPLOAD = 'FILEUPLOAD'
export const FILEUPLOAD_SUCCESS = 'FILEUPLOAD_SUCCESS'
export const FILEUPLOAD_FAILED = 'FILEUPLOAD_FAILED'

export const LOAD_WHOLESALERS = 'LOAD_WHOLESALERS'
export const LOAD_WHOLESALERS_SUCCESS = 'LOAD_WHOLESALERS_SUCCESS'
export const LOAD_WHOLESALERS_FAILED = 'LOAD_WHOLESALERS_FAILED'

export const CREATE_WHOLESALER = 'CREATE_WHOLESALER'
export const CREATE_WHOLESALER_SUCCESS = 'CREATE_WHOLESALER_SUCCESS'
export const CREATE_WHOLESALER_FAILED = 'CREATE_WHOLESALER_FAILED'

export const LOAD_WHOLESALER = 'LOAD_WHOLESALER'
export const LOAD_WHOLESALER_SUCCESS = 'LOAD_WHOLESALER_SUCCESS'
export const LOAD_WHOLESALER_FAILED = 'LOAD_WHOLESALER_FAILED'

export const LOAD_WHOLESALER_ORDERSYSTEMS = 'LOAD_WHOLESALER_ORDERSYSTEMS'
export const LOAD_WHOLESALER_ORDERSYSTEMS_SUCCESS = 'LOAD_WHOLESALER_ORDERSYSTEMS_SUCCESS'
export const LOAD_WHOLESALER_ORDERSYSTEMS_FAILED = 'LOAD_WHOLESALER_ORDERSYSTEMS_FAILED'

export const LOAD_WHOLESALER_SERVICES = 'LOAD_WHOLESALER_SERVICES'
export const LOAD_WHOLESALER_SERVICES_SUCCESS = 'LOAD_WHOLESALER_SERVICES_SUCCESS'
export const LOAD_WHOLESALER_SERVICES_FAILED = 'LOAD_WHOLESALER_SERVICES_FAILED'

export const TOGGLE_WHOLESALER_SERVICE = 'TOGGLE_WHOLESALER_SERVICE'
export const TOGGLE_WHOLESALER_SERVICE_SUCCESS = 'TOGGLE_WHOLESALER_SERVICE_SUCCESS'
export const TOGGLE_WHOLESALER_SERVICE_FAILED = 'TOGGLE_WHOLESALER_SERVICE_FAILED'

export const CLEAR_WHOLESALER = 'CLEAR_WHOLESALER'

export const DELETE_WHOLESALER_CATALOGS = 'DELETE_WHOLESALER_CATALOGS'
export const DELETE_WHOLESALER_CATALOGS_SUCCESS = 'DELETE_WHOLESALER_CATALOGS_SUCCESS'
export const DELETE_WHOLESALER_CATALOGS_FAILED = 'DELETE_WHOLESALER_CATALOGS_FAILED'

export const CREATE_WHOLESALER_CATALOGS = 'CREATE_WHOLESALER_CATALOGS'
export const CREATE_WHOLESALER_CATALOGS_SUCCESS = 'CREATE_WHOLESALER_CATALOGS_SUCCESS'
export const CREATE_WHOLESALER_CATALOGS_FAILED = 'CREATE_WHOLESALER_CATALOGS_FAILED'

export const EDIT_WHOLESALER_CATALOGS = 'EDIT_WHOLESALER_CATALOGS'
export const EDIT_WHOLESALER_CATALOGS_SUCCESS = 'EDIT_WHOLESALER_CATALOGS_SUCCESS'
export const EDIT_WHOLESALER_CATALOGS_FAILED = 'EDIT_WHOLESALER_CATALOGS_FAILED'

export const GET_WHOLESALER_CATALOGS = 'GET_WHOLESALER_CATALOGS'
export const GET_WHOLESALER_CATALOGS_SUCCESS = 'GET_WHOLESALER_CATALOGS_SUCCESS'
export const GET_WHOLESALER_CATALOGS_FAILED = 'GET_WHOLESALER_CATALOGS_FAILED'

export const GET_EXTERNAL_RESOURCES = 'GET_EXTERNAL_RESOURCES'
export const GET_EXTERNAL_RESOURCES_SUCCESS = 'GET_EXTERNAL_RESOURCES_SUCCESS'
export const GET_EXTERNAL_RESOURCES_FAILED = 'GET_EXTERNAL_RESOURCES_FAILED'

export const UPLOAD_JSON_FORM = 'UPLOAD_JSON_FORM'
export const UPLOAD_JSON_FORM_SUCCESS = 'UPLOAD_JSON_FORM_SUCCESS'
export const UPLOAD_JSON_FORM_FAILED = 'UPLOAD_JSON_FORM_FAILED'

export const DOWNLOAD_JSON_FORM = 'DOWNLOAD_JSON_FORM'
export const DOWNLOAD_JSON_FORM_SUCCESS = 'DOWNLOAD_JSON_FORM_SUCCESS'
export const DOWNLOAD_JSON_FORM_FAILED = 'DOWNLOAD_JSON_FORM_FAILED'

export const DOWNLOAD_JSON_FORM_TEMPLATE = 'DOWNLOAD_JSON_FORM_TEMPLATE'
export const DOWNLOAD_JSON_FORM_TEMPLATE_SUCCESS = 'DOWNLOAD_JSON_FORM_TEMPLATE_SUCCESS'
export const DOWNLOAD_JSON_FORM_TEMPLATE_FAILED = 'DOWNLOAD_JSON_FORM_TEMPLATE_FAILED'
